<template>
    <div class="srcBg" ref="printArea">
      <div class="scene-report-container">
          <div class="document-title">
              <img class="logo" :src="data.exportConfig.serviceReportLogo || ''">
              <span>{{ data.exportConfig.sceneReportTitle }}</span>
          </div>
          <div class="content-table">
              <div class="line">
                  <div class="cols-3">客户名称</div>
                  <div class="cols-13">{{data.clientName}}</div>
                  <div class="cols-3">区域</div>
                  <div class="cols-5">{{data.areaName}}</div>
              </div>
              <div class="line">
                  <div class="cols-3">派工单号</div>
                  <div class="cols-5">{{data.dispatchSn}}</div>
                  <div class="cols-3">服务工程师</div>
                  <div class="cols-5">{{data.engineerName}}</div>
                  <div class="cols-3">工号</div>
                  <div class="cols-5">{{data.engineerSn}}</div>
              </div>
              <div class="line">
                  <div class="cols-3">报修时间</div>
                  <div class="cols-5">{{data.creationTime}}</div>
                  <div class="cols-3">到达时间</div>
                  <div class="cols-5">{{data.arrivalTime}}</div>
                  <div class="cols-3">完成时间</div>
                  <div class="cols-5">{{data.finishTime}}</div>
              </div>
              <div v-for="(value, index) in data.repairMtList" :key="index">
                  <div v-for="(detail, i) in value.serviceDetails" :key="i">
                    <div class="double-line"></div>
                    <div class="line">
                        <div class="center"><span t="sceneReport_En10">服务</span>{{serverCount + 1}}</div>
                    </div>
                    <div class="line">
                        <div class="cols-3" v-if="data.exportConfig.serviceReportName === '1'">设备编号1</div>
                        <div class="cols-3"  v-if="data.exportConfig.serviceReportName === '2'">设备编号2</div>
                        <div class="cols-5">{{value.mtSn}}</div>
                        <div class="cols-3" v-if="data.exportConfig.serviceReportName === '1'">设备类型1</div>
                        <div class="cols-3" v-if="data.exportConfig.serviceReportName === '2'">设备类型2</div>
                        <div class="cols-5">{{value.mtModelName}}</div>
                        <div class="cols-3">到货日期</div>
                        <div class="cols-5">{{value.deliveredDate}}</div>
                    </div>
                    <div class="line">
                        <div class="cols-3">服务类型</div>
                        <div class="cols-5">{{value.name}}</div>
                        <div class="cols-3"></div>
                        <div class="cols-5"></div>
                        <div class="cols-3" v-if="data.exportConfig.serviceReportName == '1'">设备保修1</div>
                        <div class="cols-3" v-if="data.exportConfig.serviceReportName == '2'">设备保修2</div>
                        <div class="cols-5">{{value.warrantyStatus===1 ? '保内' : '保外'}}</div>
                    </div>
                    <div class="line">
                        <div class="cols-3">服务结果</div>
                        <div class="cols-5">{{dictionaryCom(detail.serviceResult, serverResults)}}</div>
                        <div class="cols-3">下一步安排</div>
                        <div class="cols-13"><div class="next-work" :title="detail.furtherWork" style="text-align: left;">{{detail.furtherWork}}</div></div>
                    </div>
                    <div class="details">
                        <div class="detail-title">需求/故障：</div>
                        <div class="clear detail-content">
                            {{detail.detail}}<br/>
                        </div>
                        <div class="detail-title">处理过程：</div>
                        <div class="detail-content clear">
                            {{detail.process}}<br/>
                        </div>
                        <div v-if="detail.name=='维修'">
                            <div class="detail-title">故障原因：</div>
                            <div class="detail-content clear">
                                {{detail.faultCauseDetail}}<br/>
                            </div>
                        </div>
                        <div v-if="detail.picAttachs && detail.picAttachs.length">
                            <div class="detail-title">现场图片：</div>
                            <div class="detail-attachment clear">
                                <div class="img-wrap" v-for="(pic, picIndex) in detail.picAttachs" :key="picIndex">
                                    <img :src="pic.url"  class="img">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="detail.subPartReplacements && detail.subPartReplacements.length">
                        <div class="line-center">
                            <div class="cols-4">备件名称</div>
                            <div class="cols-10">备件型号</div>
                            <div class="cols-5">坏件编号</div>
                            <div class="cols-5">新件编号</div>
                        </div>
                        <div class="line-center" v-for="(sub, subIndex) in detail.subPartReplacements" :key="subIndex">
                            <div class="cols-4">{{sub.partName}}</div>
                            <div class="cols-10">{{sub.usedPartModel}}</div>
                            <div class="cols-5">{{sub.usedPartSn}}</div>
                            <div class="cols-5">{{sub.newPartSn}}</div>
                        </div>
                    </div>
                    <div class="line" v-else>
                        <div class="text-left pad-left" t="sceneReport_En29">无备件更换</div>
                    </div>
                  </div>
              </div>
              <div class="double-line"></div>
              <div class="server-evaluate">
                  <div class="col-2 server-evaluate-title" t="sceneReport_En30">服务评价及建议</div>
                  <div class="col-4 server-detail">
                      <div class="col-6 none-border-top" t="sceneReport_En31">响应速度</div>
                      <div class="col-6 none-border-top">{{data.speed}}</div>
                      <div class="col-6">服务态度</div>
                      <div class="col-6">{{data.attitude}}</div>
                      <div class="col-6">服务能力</div>
                      <div class="col-6">{{data.ability}}</div>
                      <div class="col-6">满意度</div>
                      <div class="col-6">{{data.satisfaction}}</div>
                  </div>
                  <div class="col-6 server-evaluate none-border-top">
                      <div class="col-12 evaluate-title">评价/建议</div>
                      <div class="col-12 evaluate-content">{{data.comment}}</div>
                  </div>
              </div>
              <div class="line">
                  <div class="col-2 text-left pad-left">备注：</div><div class="col-10">{{data.remark}}</div>
              </div>
              <div class="sign-block">
                  <div class="col-6 engineer">
                      <div class="col-4">
                          <p>服务工程师</p><p class="sign-data">姓名</p>
                      </div>
                      <div class="col-8 engineer-name">
                          <p>{{data.engineerName}}</p>
                      </div>
                  </div>
                  <div class="col-6 customer">
                      <div v-if="data.clientSignature">
                          <div class="sign-title col-3">客户签字/日期</div>
                          <div class="sign-picture col-5">
                              <img :src="data.clientSignature" :alt="'客户签名'"  v-if="data.clientSignature"/>
                          </div>
                          <div class="sign-date col-3">
                              {{data.signDate}}
                          </div>
                      </div>
                      <div v-else>
                          <div class="no-sign-title">客户未签字（原因）</div>
                          <div class="no-sign-reason">
                              {{data.unsignedReason}}
                          </div>
                          <div class="no-sign-date">
                              {{data.signDate}}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="note clear">
              <p>{{ data.exportConfig.serviceReportNotes }}</p>
          </div>
          <div>
              <p class="footer">{{ data.exportConfig.serviceReportFooter }}</p>
          </div>
      </div>
    </div>
</template>
<script>
import dictionary from "../../plugins/dictionary"
export default {
  data () {
    return {
      data: {
        exportConfig :{
          serviceReportLogo: ''
          }
      },
      id: this.$route.query.id,
      serverCount: 0,
      serverResults: dictionary.serverResults
    }
  },
  methods: {
    initMounted () {
      this.read()
    },
    // 字典对比
    dictionaryCom (index, list) {
        if (index || index === 0) {
            for (let item of list) {
                if (item.id === index) {
                    return item.name
                }
            }
        }
        return ''
    },
    read () {
      this.$store.dispatch('a:searchServerList/onsiteReportView', {assistantReportId: this.id}).then(
        res => {
          this.data = res
          if (this.id) {
            setTimeout(function () {
                document.getElementsByTagName('body')[0].style.zoom = 1 // 设置打印缩放比例
                // print.portrait = false // 默认设置横向打印
                window.print()
                // this.$print(this.$refs.printArea)
            }, 2000)
          }
        },
        rej => {
          this.$message.error(rej.errorInfo);
        }
      )
    }
  },
  mounted () {
      this.initMounted()
  }
}
</script>
<style lang="scss" scoped>
.srcBg {
    width: 100%;
    background-color: #ffffff;
    font-size: 15px;
}
html,body {
  background-color: #ffffff;
}
.scene-report-container {
  /* position: absolute;
  left: 50%;
  margin-left: -450px; */
  // width: 100%;
  width: 720px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  font-size: 13px;
}
.scene-report-container .document-title {
  position: relative;
  font-size: 30px;
  font-weight: bolder;
  margin: 0 5px 5px;
  text-align: center;
}
.scene-report-container .document-title img {
  position: absolute;
  left: 40px;
  top: 0;
  display: inline-block;
  height: 40px;
  width: 40px;
}
.content-table {
  width: 100%;
  border-right: 1px solid #CCCCCC;
}
.content-table .line,
.content-table .line-center {
  height: 32px;
  line-height: 32px;
}
.content-table .line div,
.content-table .line-center div {
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.content-table .line div:nth-child(odd),
.content-table .line-center div:nth-child(odd) {
  text-align: center;
}
.content-table .line div:nth-child(even),
.content-table .line-center div:nth-child(even) {
  padding-left: 5px;
}
.content-table .line-center {
  text-align: center;
}
.details {
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.details .detail-title {
  padding-left: 5px;
  height: 40px;
  line-height: 40px;
}
.details .detail-content {
  min-height: 80px;
  padding: 0px 40px;
}
.details .detail-attachment {
  margin-left: 10px;
}
.details .detail-attachment .img-wrap {
  display: inline-block;
  margin: 5px;
  height: 190px;
}
.details .detail-attachment .img-wrap .img {
  height: 100%;
}
.server-evaluate {
  height: 160px;
  border-top: 1px solid #CCCCCC;
}
.server-evaluate .server-evaluate-title {
  border-left: 1px solid #CCCCCC;
  height: 160px;
  line-height: 160px;
  box-sizing: border-box;
  text-align: center;
}
.server-evaluate .server-detail div {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
  padding-left: 5px;
}
.server-evaluate .server-evaluate {
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.server-evaluate .server-evaluate .evaluate-title {
  height: 40px;
  line-height: 40px;
  padding-left: 5px;
}
.server-evaluate .server-evaluate .evaluate-content {
  height: 120px;
  padding: 5px 10px;
}
.sign-block {
  height: 160px;
}
.sign-block .engineer {
  text-align: center;
}
.sign-block .engineer div {
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
  padding-top: 40px;
  height: 160px;
}
.sign-block .engineer .engineer-name {
  font-size: 1.4em;
}
.sign-block .customer {
  text-align: left;
  height: 160px;
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.sign-block .customer .sign-title {
  padding: 5px;
}
.sign-block .customer .sign-picture {
  height: 160px;
}
.sign-block .customer .sign-picture img {
  margin-top: 1px;
  height: 98%;
}
.sign-block .customer .sign-date {
  padding-top: 120px;
  text-align: right;
}
.sign-block .customer .no-sign-title {
  padding: 5px;
}
.sign-block .customer .no-sign-reason {
  padding: 5px 10px 5px 145px;
  min-height: 85px;
}
.sign-block .customer .no-sign-date {
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
}
.note {
  border-top: 1px solid #CCCCCC;
}
.footer {
  margin-top: 40px;
  color: #999;
}
.col-1 {
  float: left;
  width: 8.33333333%;
}
.col-2 {
  float: left;
  width: 16.66666667%;
}
.col-3 {
  float: left;
  width: 25%;
}
.col-4 {
  float: left;
  width: 33.33333333%;
}
.col-5 {
  float: left;
  width: 41.66666667%;
}
.col-6 {
  float: left;
  width: 50%;
}
.col-7 {
  float: left;
  width: 58.33333333%;
}
.col-8 {
  float: left;
  width: 66.66666667%;
}
.col-9 {
  float: left;
  width: 75%;
}
.col-10 {
  float: left;
  width: 83.33333333%;
}
.col-11 {
  float: left;
  width: 91.66666667%;
}
.col-12 {
  float: left;
  width: 100%;
}
.cols-1 {
  float: left;
  width: 4.16666667%;
}
.cols-2 {
  float: left;
  width: 8.33333333%;
}
.cols-3 {
  float: left;
  width: 12.5%;
  font-size: 13px;
}
.cols-4 {
  float: left;
  width: 16.66666667%;
  font-size: 13px;
}
.cols-5 {
  float: left;
  width: 20.83333333%;
  font-size: 13px;
}
.cols-6 {
  float: left;
  width: 25%;
  font-size: 13px;
}
.cols-7 {
  float: left;
  width: 29.16666667%;
}
.cols-8 {
  float: left;
  width: 33.33333333%;
}
.cols-9 {
  float: left;
  width: 37.5%;
}
.cols-10 {
  float: left;
  width: 41.66666667%;
}
.cols-11 {
  float: left;
  width: 45.83333333%;
}
.cols-12 {
  float: left;
  width: 50%;
}
.cols-13 {
  float: left;
  width: 54.16666667%;
  font-size: 13px;
}
.cols-14 {
  float: left;
  width: 58.33333333%;
  font-size: 13px;
}
.cols-15 {
  float: left;
  width: 62.5%;
  font-size: 13px;
}
.cols-16 {
  float: left;
  width: 66.66666667%;
  font-size: 13px;
}
.cols-17 {
  float: left;
  width: 70.83333333%;
  font-size: 13px;
}
.cols-18 {
  float: left;
  width: 75%;
  font-size: 13px;
}
.cols-19 {
  float: left;
  width: 79.16666667%;
  font-size: 13px;
}
.cols-20 {
  float: left;
  width: 83.33333333%;
  font-size: 13px;
}
.cols-21 {
  float: left;
  width: 87.5%;
  font-size: 13px;
}
.cols-22 {
  float: left;
  width: 91.66666667%;
  font-size: 13px;
}
.cols-23 {
  float: left;
  width: 95.83333333%;
  font-size: 13px;
}
.cols-24 {
  float: left;
  width: 100%;
  font-size: 13px;
}
.clear {
  clear: both;
}
.pad-left {
  padding-left: 10px;
}
.border-top {
  border-top: 1px solid #CCCCCC;
}
.border-left {
  border-left: 1px solid #CCCCCC;
}
.none-border-top {
  border-top: 0 !important;
}
.double-line {
  height: 1px;
  background: #CCCCCC;
  padding: 0 0 2px;
  background-clip: content-box;
  border-left: 1px solid #CCCCCC;
}
.box {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.line-height {
  height: 40px;
  line-height: 40px;
}
.box-border {
  box-sizing: border-box;
  border-top: 1px solid #CCCCCC;
  border-left: 1px solid #CCCCCC;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.next-work {
  max-width: 500px;
  border: none !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
